"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _reactVirtualized = require("react-virtualized");
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _heading = require("../heading");
var _stepper = require("../stepper");
var _misc = require("../misc");
var _helpers = require("./helpers");
var _Timepicker = _interopRequireDefault(require("./Timepicker.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable react/no-unused-class-component-methods */
var TimePicker = /*#__PURE__*/function (_PureComponent) {
  function TimePicker(props) {
    var _this;
    _classCallCheck(this, TimePicker);
    _this = _callSuper(this, TimePicker, [props]);
    _defineProperty(_this, "onChange", function (index, time) {
      _this.setState({
        isOpen: false,
        activeIndex: index
      });
      _this.props.onChange(time);
    });
    _defineProperty(_this, "onMeridiemChange", function (tabIndex) {
      _this.setState({
        meridiemType: _helpers.MERIDIEM_TYPE[tabIndex]
      });
    });
    _defineProperty(_this, "handleFocus", function () {
      var activeIndex = _this.state.activeIndex;
      _this.setState(function () {
        return {
          isOpen: true
        };
      }, function () {
        _this.listRef.current.scrollToRow(activeIndex || 0);
      });
      _this.props.onFocus();
    });
    _defineProperty(_this, "handleClickOutside", function () {
      _this.setState({
        isOpen: false
      });
    });
    _defineProperty(_this, "renderListItems", function (_ref) {
      var index = _ref.index,
        style = _ref.style,
        hours = _ref.hours,
        activeIndex = _ref.activeIndex;
      var hour = R.prop(index, hours);
      return /*#__PURE__*/_react["default"].createElement("button", {
        key: hour,
        className: index === activeIndex ? 'active' : '',
        onClick: function onClick() {
          return _this.onChange(index, hour);
        },
        style: style
      }, hour);
    });
    var isMeridiem = props.isMeridiem;
    _this.state = {
      isOpen: false,
      activeIndex: null,
      meridiemType: isMeridiem ? _helpers.MERIDIEM_TYPE[0] : '',
      hours: (0, _helpers.setHours)(isMeridiem)
    };
    _this.listRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(TimePicker, _PureComponent);
  return _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        value = _this$props.value,
        placeholder = _this$props.placeholder,
        isMeridiem = _this$props.isMeridiem,
        position = _this$props.position,
        withIcon = _this$props.withIcon,
        errors = _this$props.errors,
        disabled = _this$props.disabled;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        activeIndex = _this$state.activeIndex,
        hours = _this$state.hours,
        meridiemType = _this$state.meridiemType;
      var time = value instanceof Date ? (0, _helpers.getTime)(value, isMeridiem) : (0, _helpers.checkTimeFormat)({
        value: value,
        hours: hours,
        isMeridiem: isMeridiem
      });
      return /*#__PURE__*/_react["default"].createElement(_Timepicker["default"], {
        className: "timepicker-wrapper",
        position: position
      }, /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        id: "".concat(id, "Input"),
        type: "text",
        disabled: disabled,
        placeholder: placeholder,
        icon: withIcon ? 'ion-android-time' : '',
        errors: errors,
        onFocus: this.handleFocus,
        value: time,
        readOnly: true
      }), isOpen && /*#__PURE__*/_react["default"].createElement(_misc.StyledDropdown, {
        className: "timepicker-dropdown"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "header"
      }, /*#__PURE__*/_react["default"].createElement(_heading.H3, null, _helpers.TIME_LABEL), isMeridiem && /*#__PURE__*/_react["default"].createElement(_stepper.Tabs, {
        view: "pill",
        defaultActiveTabIndex: R.indexOf(meridiemType, _helpers.MERIDIEM_TYPE),
        onTabChange: this.onMeridiemChange
      }, /*#__PURE__*/_react["default"].createElement(_stepper.Tab, {
        allowNavigation: true,
        label: _helpers.MERIDIEM_TYPE[0]
      }), /*#__PURE__*/_react["default"].createElement(_stepper.Tab, {
        allowNavigation: true,
        label: _helpers.MERIDIEM_TYPE[1]
      }))), /*#__PURE__*/_react["default"].createElement(_reactVirtualized.AutoSizer, {
        disableHeight: true
      }, function (_ref2) {
        var width = _ref2.width;
        return /*#__PURE__*/_react["default"].createElement(_reactVirtualized.List, {
          ref: _this2.listRef,
          rowCount: R.length(hours),
          width: width,
          height: _helpers.LIST_HEIGHT,
          rowHeight: _helpers.ROW_HEIGHT,
          rowRenderer: function rowRenderer(_ref3) {
            var index = _ref3.index,
              style = _ref3.style;
            return _this2.renderListItems({
              index: index,
              style: style,
              hours: hours,
              activeIndex: activeIndex
            });
          },
          overscanRowCount: 3
        });
      }), /*#__PURE__*/_react["default"].createElement("div", null)));
    }
  }]);
}(_react.PureComponent);
TimePicker.defaultProps = {
  value: '',
  placeholder: 'hh:mm',
  position: 'bottom',
  disabled: false,
  isMeridiem: false,
  withIcon: false,
  errors: undefined,
  onFocus: function onFocus() {}
};
TimePicker.propTypes = {
  /** Html id */
  id: _propTypes["default"].string.isRequired,
  /** Value can be in instance of Date which will extract the time or '00:00' || '12:00 AA' string format */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** The short hint displayed in the input before the user enters a value. */
  placeholder: _propTypes["default"].string,
  /** The position where to render the calendar (relative to the input) */
  position: _propTypes["default"].oneOf(['top', 'left', 'bottom', 'right']),
  /** Html id */
  disabled: _propTypes["default"].bool,
  /** The time value */
  onChange: _propTypes["default"].func.isRequired,
  /** A list of erros associated to the input */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  onFocus: _propTypes["default"].func,
  isMeridiem: _propTypes["default"].bool,
  withIcon: _propTypes["default"].bool
};
var _default = exports["default"] = (0, _reactClickOutside["default"])(TimePicker);